import { useMediaQuery } from '@mantine/hooks';
import { BaseLayout as ExternalBaseLayout, Notifications } from '@uag/react-core';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import useBreadcrumbs, { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';

import { useGetInboxToken } from 'api/notifications/inbox/inbox';
import { useGetSenderImageHook } from 'api/notifications/messages/messages';
import { BreadcrumbContext } from './BreadcrumbContext';
import { Breadcrumbs } from './Breadcrumbs';

export const BaseLayout = (props: React.ComponentProps<typeof ExternalBaseLayout>) => {
    const { children, ...rest } = props;
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { data: inboxToken, isLoading: isInboxTokenLoading } = useGetInboxToken(undefined, {
        query: { enabled: !!import.meta.env.VITE_APP_NOTIFICATIONS_API_URL },
    });
    const getSenderImage = useGetSenderImageHook();
    const getUserImageUrl = async (userId: string) => {
        const senderImageModel = await getSenderImage(userId);
        return senderImageModel?.data?.imageUri ?? undefined;
    };

    const baseBreadcrumbRoute: BreadcrumbsRoute = {
        path: '/',
        breadcrumb: '',
    };
    const breadcrumbRoutes = useContext(BreadcrumbContext);
    const breadcrumbs = useBreadcrumbs([baseBreadcrumbRoute, ...breadcrumbRoutes]);
    const navigate = useNavigate();

    const handleLogoCLick = () => {
        navigate('/', { state: { preventRedirect: true } });
    };

    return (
        <ExternalBaseLayout
            versionNumber={APP_VERSION}
            onLogoClick={handleLogoCLick}
            {...rest}
            background="gray"
            innerClassName="h-min"
        >
            <ExternalBaseLayout.HeaderItems>
                <Notifications
                    apiKey={inboxToken?.data?.publicApiKey ?? undefined}
                    getUserImageUrl={getUserImageUrl}
                    isLoading={isInboxTokenLoading}
                    userId={inboxToken?.data?.userIdentifier}
                    userToken={inboxToken?.data?.token}
                />
            </ExternalBaseLayout.HeaderItems>
            <ExternalBaseLayout.Content>
                {breadcrumbs && breadcrumbs.length > 1 && (
                    <Breadcrumbs breadcrumbs={breadcrumbs} maxElements={isMobile ? 2 : undefined} />
                )}
                {children}
            </ExternalBaseLayout.Content>
        </ExternalBaseLayout>
    );
};
